const departments = {
  Agriculture: [
    'Agricultural Economics and Farm Management',
    'Agricultural Extension and Rural Development',
    'Agronomy',
    'Animal Production',
    'Crop Protection ',
    'Home Economics and Food Science',
    'Forest Resources Management',
    'Aquaculture and Fisheries',
  ],
  Arts: [
    'Arabic',
    'Christian Studies',
    'Comparative Religious Studies',
    'English Language',
    'French',
    'History and International Studies',
    'Islamic Sudies',
    'Linguistics',
    'Performing Arts',
    'Yoruba',
  ],
  'Basic Clinical Sciences': [
    'Chemical Pathology and Immunology',
    'Haematology & Blood Transfusion',
    'Medical Laboratory Science',
    'Pharmacology & Therapeutics',
    'Pathology',
    'Medical Microbiology and Parasitology',
    'Physiotherapy',
  ],
  'Basic Medical Sciences': ['Anatomy', 'Medical Biochemistry', 'Physiology'],
  'Clinical Sciences': [
    'Anaesthesia',
    'Behavioural Sciences',
    'Dentistry',
    'Epidemiology & Community Health',
    'Family Medicine',
    'Medicine',
    'Nursing Science',
    'Obstetrics & Gynaecology',
    'Ophthalmology',
    'Otorhinolaryngology',
    'Paediatrics and Child Health',
    'Radiology',
    'Surgery',
  ],
  'Communication and Information Sciences': [
    'Computer Science',
    'Information & Communication Science',
    'Library & Information Sciences',
    'Mass Communication',
    'Telecommunication Science',
  ],
  Education: [
    'Adult and Primary Education Studies',
    'Arts Education',
    'Counsellor Education',
    'Educational Management',
    'Educational Technology',
    'Health Promotion and Environmental Health Education',
    'Human Kinetics Education',
    'Science Education',
    'Social Sciences Education',
  ],
  'Engineering and Technology': [
    'Agric. And Biosystems Engineering',
    'Biomedical Engineering',
    'Chemical Engineering',
    'Civil Engineering',
    'Computer Engineering',
    'Electrical & Electronics Engineering',
    'Food and Bioprocess Engineering',
    'Materials & Metallurgical Engineering',
    'Mechanical Engineering',
    'Water Resources and Environmental Engineering',
  ],
  'Environmental Sciences': [
    'Architecture',
    'Estate Management',
    'Quantity Surveying',
    'Surveying and Geo-informatics',
    'Urban and Regional Planning',
  ],
  Law: [
    'Business law',
    'Common and Islamic Law',
    'Jurisprudence and International law',
    'Private and Property law',
    'Public law',
  ],
  'Life sciences': [
    'Biochemistry',
    'Microbiology',
    'Optometry & Vision Science',
    'Plant Biology',
    'Zoology',
  ],
  'Management Sciences': [
    'Accounting',
    'Business Administration',
    'Finance',
    'Marketing',
    'Industrial Relations & Personnel Management',
    'Public Administration',
  ],
  'Pharmaceutical Sciences': [
    'Clinical Pharmacy & Pharmacy Practice',
    'Pharmaceutics & Industrial Pharmacy',
    'Pharm. Microbiology & Biotechnology',
    'Pharmacognosy & Drug Development',
    'Pharmaceutical and Medicinal Chemistry',
    'Pharmacology & Toxicology',
  ],
  'Physical Sciences': [
    'Chemistry',
    'Geology',
    'Geophysics',
    'Industrial Chemistry',
    'Mathematics',
    'Physics',
    'Statistics',
  ],
  'Social Sciences': [
    'Criminology and Security Studies',
    'Economics',
    'Geography & Environmental Managemen',
    'Political Science',
    'Psychology',
    'Social Work',
    'Sociology',
  ],
  'Veterinary Medicine': [
    'Veterinary Anatomy',
    'Veterinary Medicine',
    'Veterinary Microbiology',
    'Veterinary Parasitology and Entomology',
    'Veterinary Pathology',
    'Veterinary Physiology and Biochemistry',
    'Pharmacology and Toxicology',
    'Veterinary Public Health and Preventive Medicine',
    'Theriogenology and Production',
    'Veterinary Surgery and Radiology',
  ],
};

export default departments;
